import { Row } from '@tanstack/react-table'
import { generatePath } from 'react-router-dom'

import { ROUTES } from 'routes'
import { UserActionsCell } from '../../Cell/UserActionsCell'
import { useDeleteUser } from '../../hooks/useDeleteUser'
import { EmployeeForTable } from '../types'

export const ActionsCell = ({ email, id }: Row<EmployeeForTable>['original']): JSX.Element => {
  const { deleteUser, loading } = useDeleteUser({
    email,
    queriesToInvalidate: ['getEmployeesForTable'],
  })

  return (
    <UserActionsCell
      editPath={generatePath(ROUTES.USER.EMPLOYEE.EDIT, { id })}
      id={id}
      loading={loading}
      onDelete={() => deleteUser(id)}
    />
  )
}
